import type {EmailTemplate} from "$lib/types/EmailTemplate";
import dayjs from "dayjs";
import {asValue} from "$lib/utils/lenkradDate";
import {formatCurrency} from "$lib/utils/currency";


export default function parseHandlebars(template: EmailTemplate, data: any): string {
    let html = template.content;
    html = html.replace(`{{currentYear}}`, dayjs().format('YYYY'));
    template.placeholders.forEach((placeholder: any) => {
        let fillIn = placeholder.templateProperty;
        try {
            console.log({
                entity: placeholder.entity,
                found: data[placeholder.entity],
                property: placeholder.entityProperty,
                target: placeholder.templateProperty,
                fillIn: fillIn
            })
            fillIn = data[placeholder.entity][placeholder.entityProperty];
            let matcher;
            if (typeof fillIn !== 'undefined' && placeholder.formatter) {
                switch (placeholder.formatter) {
                    case 'currency':
                        fillIn = formatCurrency(fillIn, 'EUR');
                        break;
                    case 'date':
                        if(!asValue(fillIn)) {
                            fillIn = 'unbefristet'
                        } else {
                            fillIn = dayjs(asValue(fillIn)).format('DD.MM.YYYY');
                        }

                        break;
                    case 'time':
                        fillIn = dayjs(asValue(fillIn)).format('HH:mm');
                        break;
                    case 'matcher':
                        matcher = JSON.parse(placeholder.matcher);
                        fillIn = matcher[fillIn] || fillIn;
                        break;
                    case 'link':
                        matcher = JSON.parse(placeholder.matcher);
                        fillIn = matcher.link.replace(/{{(.*?)}}/g, fillIn)
                        break;
                }
            }


        } catch (e) {
            console.log('error', e)
        }
        if (placeholder.entity === 'Input' && typeof data[placeholder.entity][placeholder.templateProperty] !== 'undefined') {
            if (placeholder.entityProperty === 'date') {
                fillIn = dayjs(asValue(data[placeholder.entity][placeholder.templateProperty])).format('DD.MM.YYYY');
            } else if (placeholder.entityProperty === 'matcher') {
                const matcher = JSON.parse(placeholder.matcher);
                fillIn = data[placeholder.entity][placeholder.templateProperty];
                fillIn = matcher[fillIn] || fillIn;
            } else {
                fillIn = data[placeholder.entity][placeholder.templateProperty];
            }

        }
        if (typeof fillIn !== 'undefined') {
            html = html.replace(`{{${placeholder.templateProperty}}}`, fillIn);
            const regEx = new RegExp("\{\{var:" + placeholder.templateProperty + "(:[^}]+)*\}\}", 'g');
            html = html.replace(regEx, fillIn);
        }

    })
    return html;
}

export const findUnmatchedVariables = (html: string) => {
    const regEx = new RegExp("\{\{var:[^}]+(:[^}]+)*\}\}", 'g');
    const instances = html.match(regEx);
    const variables: { variable: string, value: string }[] = [];
    instances?.forEach(instance => {
        const cleanInstance = instance.replace('{{var:', '').replace('}}', '').replace(':', '');
        if (!variables.find(variable => variable.variable === cleanInstance)) {
            variables.push({
                variable: cleanInstance,
                value: ''
            });
        }
    })
    return variables;
}